export default "__VITE_ASSET__Dnxibp$0__"